<template>
  <Wrapper
      @open="onClick"
      :icon="ICONS.commentDots"
      label="Комментарий"
      code="comment"
  >
    <div class="c-view s-font-2xs">
      <div>
        {{ attrs.COMMENT }}
      </div>
    </div>
  </Wrapper>
</template>

<script lang="ts" setup>

import CommentDialog from "@/components/Shop/VOrder/ui/Dialog/Comment.vue";
import {VOrderSectionProps, vorderSectionPropsDefault} from "./util";
import Wrapper from "./Wrapper/Wrapper.vue";
import {storeToRefs} from "pinia";
import {useStackRouter} from "@/packages/stack-router/hooks/useStackRouter";
import {ICONS} from "@/assets/icons";
import {useVorderState} from "@/modules/shop/store/vorder-state";

const vorderState = useVorderState()
const {attrs} = storeToRefs(vorderState)

const props = withDefaults(defineProps<VOrderSectionProps>(), {
  ...vorderSectionPropsDefault,
})

const stackRouter = useStackRouter()

const onClick = () => {
  stackRouter.getStack()?.push(CommentDialog, {role: 'vorder'})
}

</script>

<style scoped>

.c-view {
  display: table;
  table-layout: fixed;
  width: 100%;

  div {
    display: table-cell;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
